import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import './LegalPage.css';

const CONTACT_EMAIL = 'flashagency1@outlook.com';
const CONTACT_PHONE = '+852 52134313';

function TermsAndConditions() {
  const { t } = useI18n();

  return (
    <div className="legal-page">
      <h1 className="legal-page__title">{t('legal.terms.title')}</h1>
      <p className="legal-page__subtitle">{t('legal.terms.subtitle')}</p>

      <section className="legal-page__section">
        <h2>{t('legal.terms.serviceTitle')}</h2>
        <p>{t('legal.terms.serviceText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.terms.accountTitle')}</h2>
        <ul>
          <li>{t('legal.terms.accountItem1')}</li>
          <li>{t('legal.terms.accountItem2')}</li>
          <li>{t('legal.terms.accountItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.terms.goodsTitle')}</h2>
        <p>{t('legal.terms.goodsText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.terms.liabilityTitle')}</h2>
        <p>{t('legal.terms.liabilityText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.terms.intellectualTitle')}</h2>
        <p>{t('legal.terms.intellectualText')}</p>
      </section>

      <section className="legal-page__section">
        <h2>{t('legal.terms.disputeTitle')}</h2>
        <ul>
          <li>{t('legal.terms.disputeItem1')}</li>
          <li>{t('legal.terms.disputeItem2')}</li>
          <li>{t('legal.terms.disputeItem3')}</li>
        </ul>
      </section>

      <section className="legal-page__section legal-page__contact">
        <h2>{t('legal.contact.title')}</h2>
        <p>{t('footer.title')}</p>
        <p>{t('footer.companyName')}</p>
        <p>{t('footer.address')}</p>
        <p>
          {t('footer.emailLabel')}: {CONTACT_EMAIL}
        </p>
        <p>
          {t('footer.phoneLabel')}: {CONTACT_PHONE}
        </p>
      </section>
    </div>
  );
}

export default TermsAndConditions;
